// $('.products-slider').slick({
//   centerMode: true,
//   centerPadding: '170px',
//   slidesToShow: 5,
//   slidesToScroll: 5,
//   infinite: true,
//   arrows: false,
//   dots: false,
//   speed: 800,
//   cssEase: 'cubic-bezier(0.17, 0.67, 0.83, 0.67)',
//   autoplay: true,
//   autoplaySpeed: 3000,
//   responsive: [
//     {
//       breakpoint: 1350,
//       settings: {
//         arrows: false,
//         dots: false,
//         infinite: true,
//         slidesToShow: 4,
//         slidesToScroll: 4,
//         centerMode: false,
//         centerPadding: '0px',
//       }
//     },
//     {
//       breakpoint: 990,
//       settings: {
//         arrows: false,
//         dots: false,
//         infinite: true,
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         centerMode: false,
//         centerPadding: '0px',
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: false,
//         dots: false,
//         infinite: false,
//         slidesToShow: 2, // Adjust this as needed
//         slidesToScroll: 2, // Adjust this as needed
//         centerMode: false,
//         centerPadding: '0px',
//       }
//     }
//   ]
// });

  $('.products-slider').slick({
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });
